import React from "react"

const ProductCondition = ({condition, className}) => {
    if (!condition) { return null; }

    let bg_color;
    let text_color = 'text-white';

    switch (condition) {
        case 'Brand New': /* falls through */
        case 'Mint':
            bg_color = 'bg-green-500';
            break;
        case 'NOS': 
            condition = <abbr title="New Old Stock" className="subtle">{condition}</abbr>;
            bg_color = 'bg-green-500';
            break;
        case 'Excellent':
            bg_color = 'bg-purple-500';
            break;
        case 'Very Good':
            bg_color = 'bg-blue-500';
            break;
        case 'Good':
            bg_color = 'bg-yellow-200';
            text_color = 'text-black';
            break;
        case 'Fair':
            bg_color = 'bg-yellow-600';
            break;
        case 'Relic':
            bg_color = 'bg-gray-600';
            break;
        case 'Poor': /* falls through */
        case 'Non Functioning':
            bg_color = 'bg-red-500';
            break;
        default:
            bg_color = 'bg-green-500';
    }
    
    return <div className={`${className} inline-block text-xs rounded-full px-2 py-1  bg- ${bg_color} ${text_color}`}>{condition}</div>;
};

export default ProductCondition